import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ToggleFullScreenIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="18"
    height="18"
    viewBox="0 0 18 18"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      d="M12.3401 2.31787V5.65878H15.681M5.65829 2.31787V5.65878H2.31738M5.65829 15.6815V12.3406H2.31738M12.3401 15.6815V12.3406H15.6439"
      stroke="white"
      strokeWidth="1.48485"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
